
import React from 'react';
import { CreditCard } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export const EmptySubscriptions = () => {
  return (
    <Card className="border border-dashed bg-muted/20 hover:bg-muted/30 transition-colors p-8">
      <CardContent className="flex flex-col items-center justify-center text-center pt-6">
        <div className="bg-primary/10 p-3 rounded-full">
          <CreditCard className="h-10 w-10 text-primary/60" />
        </div>
        <h3 className="mt-4 text-xl font-medium">Нет активных подписок</h3>
        <p className="mt-2 text-muted-foreground">
          У вас пока нет подписок на аренду. Активные подписки появятся здесь.
        </p>
      </CardContent>
    </Card>
  );
};
